import React from "react";

import LineItem from "./lineItem";
import { readablePrice, totalQuantityInCollection } from "./cartHelpers";
import SaleHelpers from "./saleHelpers";

class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: window.Cart.items,
      loading: true,
      cartTotal: window.Cart.total_price,
      saleLimits: this.props.saleLimits || {
        active: false,
        limits: []
      },
      saleOpts: this.props.saleOpts || { active: false, toAddVariants: [] },
      notificationOpts: this.props.saleNotificationOpts || {}
    };
  }

  componentDidMount() {
    if (this.state.saleOpts) {
      this.ensureSale();
    }
    this.ensureLimits();
    this.setState({ loading: false });
  }

  componentDidUpdate() {
    if (this.state.saleOpts) {
      this.ensureSale();
    }
    this.ensureLimits();
  }

  setLoading = bool => {
    this.setState({ loading: bool });
  };

  ensureLimits = () => {
    const SL = this.state.saleLimits;
    const tolimitHandles = SL.limits.map(limit => limit.toLimitHandle);
    const existingItems = this.state.items.filter(item =>
      tolimitHandles.includes(item.handle)
    );

    if (!SL.active || existingItems.length == 0 || this.state.loading) {
      return false;
    }

    SaleHelpers.handleEnsureLimits(SL, existingItems, this.updateCartUI);
  };

  ensureSale = () => {
    if (this.state.loading || !this.state.saleOpts.active) {
      return false;
    }
    const opts = this.state.saleOpts;
    const toAddVariantId = opts.toAddVariants.filter(
      variant => variant.available
    )[0].id;

    if (opts.hasQuantityThreshold) {
      SaleHelpers.handleQuantityThreshold(
        this.state.items,
        toAddVariantId,
        opts.toAddHandle,
        opts.quantityThreshold,
        this.updateCartUI
      );
    } else if (opts.hasTotalThreshold) {
      SaleHelpers.handleTotalThreshold(
        this.state.items,
        toAddVariantId,
        opts.toAddHandle,
        opts.totalThreshold1,
        opts.totalThreshold2,
        opts.totalThreshold3,
        this.updateCartUI
      );
    } else if (opts.requiresCollection) {
      SaleHelpers.handleRequiresCollection(
        this.state.items,
        opts.requiredCollectionProducts,
        toAddVariantId,
        opts.toAddHandle,
        opts.requiredCollectionTotal,
        this.updateCartUI
      );
    } else if (opts.requiresProduct) {
      const requiredProductCount = this.state.items
        .filter(item => item.handle.includes(opts.requiredProductHandle))
        .reduce((acc, item) => {
          return acc + item.quantity;
        }, 0);

      const existingGifts = this.state.items.filter(
        item => item.handle == opts.toAddHandle
      );

      const existingGiftsCount = existingGifts.reduce((acc, item) => {
        return acc + item.quantity;
      }, 0);

      const updates = {};

      if (
        requiredProductCount > 0 &&
        existingGiftsCount < requiredProductCount
      ) {
        const variant =
          existingGifts.length > 0
            ? existingGifts[0].variant_id
            : toAddVariantId;
        updates[variant] = requiredProductCount;
      } else if (requiredProductCount < existingGiftsCount) {
        this.state.items
          .filter(item => item.handle == opts.toAddHandle)
          .forEach(item => {
            updates[item.variant_id] = 0;
          });
      }

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json",
        data: { updates: updates }
      }).done(this.updateCartUI);
    }
  };

  updateCartUI = newCart => {
    const updateState = newCart => {
      this.setState({
        items: newCart.items,
        cartTotal: newCart.total_price,
        loading: false
      });
      $(".item-count").text(newCart.item_count); // main nav items count
      $(".nav-item.cart .count span").text(newCart.item_count); // mobile nav items count
      $("#cart-form select.processed").trigger("change"); // sexydrop select might not update without triggering change, even though original select changed.
    };

    if (newCart && newCart.items) {
      updateState(newCart);
    } else {
      $.ajax({
        url: "/cart.js",
        type: "GET",
        dataType: "json"
      }).done(updateState);
    }
  };

  checkoutButton = () => {
    if (this.state.loading) {
      return (
        <input
          disabled
          style={{ backgroundColor: "#DECFC3" }}
          className="action-button"
          type="submit"
          name="checkout"
          value="Check out"
        />
      );
    } else {
      return (
        <input
          className="action-button"
          type="submit"
          name="checkout"
          value="Check out"
        />
      );
    }
  };

  saleNotification = () => {
    const opts = this.props.saleNotificationOpts;

    if (this.state.saleOpts && this.state.saleOpts.giftOutOfStock) {
      return (
        <div className="cart-banner">Sorry, gift is now out of stock.</div>
      );
    }

    if (
      this.state.items &&
      this.state.items.length > 0 &&
      opts &&
      opts.filterType == "collection"
    ) {
      let existing = totalQuantityInCollection(
        this.state.items,
        opts.collection
      );
      let remaining =
        opts.schemeBuyQuantity +
        opts.schemeGetQuantity -
        (existing % (opts.schemeBuyQuantity + opts.schemeGetQuantity));

      if (
        remaining > 0 &&
        remaining != opts.schemeBuyQuantity + opts.schemeGetQuantity
      ) {
        return (
          <div class="cart-banner">
            Add {remaining} more from &nbsp;
            <a href={opts.filterURL}>{opts.filterName}</a>
            &nbsp;to take advantage of your buy {
              opts.schemeBuyQuantity
            } get {opts.schemeGetQuantity} offer
          </div>
        );
      }
    }
    return null;
  };

  form = () => {
    const checkoutButton = this.checkoutButton();
    return (
      <form id="cart-form" action="/cart" method="post">
        {this.saleNotification()}
        <table className="table">
          <thead>
            <tr className="table-header">
              <th className="first">Product</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.state.items.map((lineItem, i) => (
              <LineItem
                items={this.state.items}
                item={lineItem}
                selectedVariant={lineItem.variant_id}
                lineNum={i + 1}
                key={lineItem.key + lineItem.quantity + lineItem.variant_id + lineItem.line_price}
                updateCartUI={this.updateCartUI}
                setLoading={this.setLoading}
                loading={this.state.loading}
              />
            ))}
          </tbody>
        </table>

        <div className="cart-tools clearfix">
          <div className="totals">
            <p className="price">{readablePrice(this.state.cartTotal)}</p>
            <p className="message">Excluding tax and shipping</p>
            {this.props.disclaimer && (
              <p className="message">{this.props.disclaimer}</p>
            )}
            <div className="checkout">{checkoutButton}</div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    let form = null;

    if (this.state.items.length < 1) {
      form = (
        <p className="empty">
          You don't have any items in your cart yet.{" "}
          <a href="/collections/all">Continue shopping.</a>
        </p>
      );
    } else {
      form = this.form();
    }

    return (
      <div>
        <div className="page-title">
          <span className="label">Cart</span>
        </div>
        {form}
      </div>
    );
  }
}

export default Cart;
